import i18n from "i18n";

export const quizEventMessages = {
  create: i18n.t('notifications.quizEvent.create'),
  update: i18n.t('notifications.quizEvent.update'),
  delete: i18n.t('notifications.quizEvent.delete'),
  trigger: i18n.t('notifications.quizEvent.trigger')
};
